import { configureStore } from "@reduxjs/toolkit";
import influencerReducer from "./influencerSlice";

const appStore = configureStore({
  reducer: {
    influencer: influencerReducer,
  },
});

export default appStore;
